import './password-input.scss';

import { forwardRef, useState } from 'react';

import { Eye, EyeOff } from '@/media/icons';

import Input, { type TInputProps } from './input';

export type TPasswordInputProps = Omit<TInputProps, 'type' | 'endContent'>;

/**
 * Поле пароля с переключателем «показать/скрыть». Обёртка над Input: держит своё состояние
 * видимости и рисует иконку-глаз в endContent (тип input переключается text↔password).
 * Пробрасывает все остальные пропсы Input (value/onChange/onBlur/error/label и т.д.).
 */
const PasswordInput = forwardRef<HTMLInputElement, TPasswordInputProps>(
  (props, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <Input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        endContent={
          <button
            type="button"
            className="password-input__toggle"
            aria-label={visible ? 'Hide password' : 'Show password'}
            aria-pressed={visible}
            // mousedown default стащил бы фокус с поля — оставляем каретку на месте.
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => setVisible((v) => !v)}
            tabIndex={-1}
          >
            {visible ? <EyeOff /> : <Eye />}
          </button>
        }
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
